import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Cardss() {
  const certifications = [
    {
      title: "CJCA",
      subtitle: "HTB Certified Junior Cybersecurity Associate",
      modules: 20,
      jobRole: "Junior Cybersecurity Analyst",
      price: "$490",
      image:
        "https://images.pexels.com/photos/5380645/pexels-photo-5380645.jpeg?auto=compress&cs=tinysrgb&w=1600", // Cybersecurity analyst typing
    },
    {
      title: "CPTS",
      subtitle: "HTB Certified Penetration Testing Specialist",
      modules: 28,
      jobRole: "Penetration Tester",
      price: "$490",
      image:
        "https://images.pexels.com/photos/5380666/pexels-photo-5380666.jpeg?auto=compress&cs=tinysrgb&w=1600", // Hacker using laptop
    },
    {
      title: "CWEE",
      subtitle: "HTB Certified Web Exploitation Expert",
      modules: 15,
      jobRole: "Senior Web Penetration Tester",
      price: "$1260",
      image:
        "https://images.pexels.com/photos/5483070/pexels-photo-5483070.jpeg?auto=compress&cs=tinysrgb&w=1600", // Code on screen
    },
    {
      title: "CBBH",
      subtitle: "HTB Certified Bug Bounty Hunter",
      modules: 20,
      jobRole: "Bug Bounty Hunter",
      price: "$490",
      image:
        "https://images.pexels.com/photos/5380619/pexels-photo-5380619.jpeg?auto=compress&cs=tinysrgb&w=1600", // Ethical hacker in hoodie
    },
    {
      title: "COSA",
      subtitle: "HTB Certified Defensive Security Analyst",
      modules: 15,
      jobRole: "SOC Analyst",
      price: "$490",
      image:
        "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg?auto=compress&cs=tinysrgb&w=1600", // Monitoring security dashboard
    },
    {
      title: "CAPE",
      subtitle: "HTB Certified Active Directory Pentesting Expert",
      modules: 15,
      jobRole: "Active Directory Penetration Tester",
      price: "$1260",
      image:
        "https://images.pexels.com/photos/5474291/pexels-photo-5474291.jpeg?auto=compress&cs=tinysrgb&w=1600", // System admin working in data center
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="bg-gradient-to-r from-red-600 to-blue-700 min-h-screen p-6 md:p-12">
      {/* Heading */}
      <div className="text-center mb-10 text-white max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Get your team certified
        </h2>
        <p className="text-gray-200 text-sm md:text-base">
          Your employees can receive comprehensive training and achieve
          certification all in one place. Each HTB certification includes a
          designated job role path leading to the certification exam,
          providing a complete upskilling and assessment experience.
        </p>
      </div>

      {/* Slider */}
      <Slider {...settings}>
        {certifications.map((cert, idx) => (
          <div key={idx} className="px-2">
            <div className="bg-black/50 rounded-xl overflow-hidden shadow-lg transform hover:scale-105 transition-transform duration-300">
              <img
                src={cert.image}
                alt={cert.title}
                className="w-full h-48 object-cover"
              />
              <div className="p-4 text-white">
                <h3 className="font-bold text-xl mb-1">{cert.title}</h3>
                <p className="text-gray-200 text-sm mb-2">{cert.subtitle}</p>

                <div className="flex justify-between text-sm text-green-400 mb-2">
                  <span>📘 {cert.modules} Modules</span>
                  <span>📝 Exam Included</span>
                </div>

                <p className="text-gray-300 text-sm mb-2">
                  Related Job Role Path: <strong>{cert.jobRole}</strong>
                </p>

                <p className="text-lg font-semibold mt-2">
                  Get certified for {cert.price}
                </p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default Cardss;
